import { FC, useEffect } from 'react'
import groupBy from 'lodash/groupBy'

import { useMessenger } from '@/hooks/useMessenger'
import { StoreContextType } from '@/context/types'
import { StoreContext } from '@/context/context'

import SendToChip from './SendToChip'

import { capitalize } from '../common/utils'
import {
  CONVERSATION_STATE,
  DEFAULT_SEND_TO,
  USER_TYPES,
} from '@/context/constants'

export interface SendToProps {
  context?: React.Context<StoreContextType | null>
}

const SendTo: FC<SendToProps> = ({ context = StoreContext }) => {
  const { getConfig, getSelectedConversation, findConversation, setSendTo } =
    useMessenger(context)

  useEffect(() => {
    const userType = getConfig()?.userType?.toLowerCase() as string

    setSendTo(DEFAULT_SEND_TO)

    if (userType !== USER_TYPES.VENDOR) {
      setSendTo({ [userType]: true })
    }
  }, [])

  const conversation = findConversation(getSelectedConversation())

  if (
    conversation?.metadata?.state !== CONVERSATION_STATE.OPEN ||
    conversation?.metadata?.type !== 'Maintenance' ||
    conversation?.metadata?.assignedVendor === null ||
    (conversation?.metadata?.assignedVendor !== getConfig()?.userExternalId &&
      getConfig()?.userType?.toLowerCase() === USER_TYPES.VENDOR)
  ) {
    return null
  }

  const renderChips = () => {
    const userType = getConfig()?.userType?.toLowerCase()
    const chips = [
      <SendToChip
        key="poplar"
        type="poplar"
        displayName="Poplar Manager"
        context={context}
      />,
    ]

    // Temporarily disable
    // const sendToOwner = (
    //   <SendToChip
    //     key={USER_TYPES.OWNER}
    //     type={USER_TYPES.OWNER}
    //     displayName={capitalize(USER_TYPES.OWNER)}
    //     context={context}
    //   />
    // )

    const sendToRenter = (
      <SendToChip
        key={USER_TYPES.RENTER}
        type={USER_TYPES.RENTER}
        displayName={capitalize(USER_TYPES.RENTER)}
        context={context}
      />
    )

    const sendToVendor = (
      <SendToChip
        key={USER_TYPES.VENDOR}
        type={USER_TYPES.VENDOR}
        displayName={capitalize(USER_TYPES.VENDOR)}
        context={context}
      />
    )

    if (userType === USER_TYPES.RENTER) {
      chips.push(sendToVendor)
    }

    if (userType === USER_TYPES.VENDOR) {
      chips.push(sendToRenter)
    }

    return chips
  }

  return (
    <div className="pmui-px-3 pmui-flex pmui-items-center pmui-gap-2">
      <div className="pmui-text-sm pmui-font-semibold pmui-min-w-fit">
        Send to
      </div>
      {renderChips()}
    </div>
  )
}

export default SendTo
